var path = 'areas/projects/action-template-fields/field-AzureAccount.html';
var html = "<div> <ui-select ng-model=vm.value append-to-body=true> <ui-select-match placeholder=\"{{vm.placeholder || 'Select Account'}}\" allow-clear=true> <i class=\"fa account-icon-{{$select.selected.AccountType}}\"></i>{{$select.selected.Name}} </ui-select-match> <ui-select-choices repeat=\"item.Id as item in vm.getSelectOptions() | filter: isAzureAccount | filter:{Name: $select.search} track by item.Id\"> <i class=\"fa account-icon-{{item.AccountType}}\"></i> <span ng-bind-html=\"item.Name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-AzureAccount.html
// module id = 8444009773324036
// module chunks = 1